/**
 * Who the signed-in user is, as far as the panel is concerned.
 *
 * `ra_role` is written at login from `response.roles`, which is an array - so
 * localStorage holds a comma-joined string ("ADMIN", or "ADMIN,SUPER_ADMIN" for
 * someone holding both). An exact === comparison against it therefore fails for
 * anyone with more than one role, which is why these split before testing.
 *
 * The checks here are positive: they ask whether a role is present rather than
 * whether it is absent. Excluding vendors would grant access to any role added
 * later by default, which is the wrong way round for a permission.
 *
 * None of this is a security boundary. The browser can set localStorage to
 * anything; these calls decide what to render. Every endpoint behind them is
 * enforced server-side with @PreAuthorize.
 */

const ADMIN_ROLES = ['ADMIN', 'SUPER_ADMIN'];

export const getRoles = (): string[] =>
    (localStorage.getItem('ra_role') ?? '')
        .split(',')
        .map(role => role.trim())
        .filter(Boolean);

/** True only for ADMIN or SUPER_ADMIN. Vendors and anything unrecognised are false. */
export const isAdmin = (): boolean =>
    getRoles().some(role => ADMIN_ROLES.includes(role));

export const isVendor = (): boolean => getRoles().includes('VENDOR');
